import React from "react";
import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import AllInterviewLogsContent from "../../../components/AdminPanel/InterviewLogs/AllInterviewLogsContent";

const InterviewLogs = () => {
  return (
    <AdminPanelLayout>
      <AllInterviewLogsContent />
    </AdminPanelLayout>
  );
};

export default InterviewLogs;

